import { Component, ElementRef, EventEmitter, inject, Input, input, Output, signal, viewChild } from '@angular/core';
import { GoogleScriptLoaderService } from 'app/services/google-script-loader/google-script-loader.service';

interface PlaceAutocompleteElementOptionsPatched extends google.maps.places.PlaceAutocompleteElementOptions {
  includedRegionCodes?: string[];
  includedPrimaryTypes?: string[];
}

@Component({
  selector: 'app-google-places-autocomplete',
  templateUrl: './google-places-autocomplete.component.html',
  styleUrl: './google-places-autocomplete.component.scss'
})
export class GooglePlacesAutocompleteComponent {
  private readonly googleMapService = inject(GoogleScriptLoaderService);
  public readonly addressGroupContainer = viewChild<ElementRef<HTMLDivElement>>('addressGroupContainer');
  // public readonly placeJson = signal(null);
  @Output() placeSelected = new EventEmitter<any>();
  @Input() placeholderLabel: string = 'Address search..';
  async ngOnInit() {
    const maps = await this.googleMapService.getGoogleMapPlaces();
    const options: PlaceAutocompleteElementOptionsPatched = {
      includedPrimaryTypes: ['geocode'],
      includedRegionCodes: ['us'] 
    };
    const placeAutocomplete = new maps.places.PlaceAutocompleteElement(options);
    placeAutocomplete.style.colorScheme = 'light';
    this.addressGroupContainer()?.nativeElement.appendChild(placeAutocomplete);

     // When a place is selected
    placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }: any) => {
      const place = placePrediction.toPlace();
      await place.fetchFields({
        fields: ['displayName', 'formattedAddress', 'location', 'addressComponents'],
      });
      // this.placeJson.set(place.toJSON());
      this.placeSelected.emit(place.toJSON());
    });
  }
}
